<script setup lang="ts">
defineProps<{
  down?: boolean | None
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
  >
    <!-- stroke-linecap="round" -->
    <template v-if="down">
      <line x1="12" y1="5" x2="12" y2="19" />
      <polyline points="19 12 12 19 5 12" />
    </template>
    <template v-else>
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </template>
  </svg>
</template>

<style module>
.cont {
  /*  */
}
</style>
